<template>
  <v-content>
    <v-dialog
      v-model="dialog.isShow"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{dialog.title}}
        </v-card-title>

        <v-card-text>
          {{dialog.content}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog.isShow = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar class="bg-color" dark extended flat>
    </v-toolbar>
    <v-layout wrap column pb-2 justify-center>
      <v-flex xs12 sm10 md8>
        <v-flex xs12 d-flex justify-center>
          <v-card class="card--flex-toolbar" style="max-width:750px">
            <v-toolbar card prominent>
              <v-toolbar-title class="body-2 grey--text">Reset Password</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm7>
                  <v-card-title class="pb-0">
                    <div>
                      <h3 class="headline mb-0">Reset your password</h3>
                      <span class="grey--text">Please type your new password below.</span>
                    </div>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
                    <v-container fluid grid-list-md>
                      <v-layout wrap>
                        <!--<v-flex xs12>
                          <v-text-field label="E-mail" disabled></v-text-field>
                        </v-flex>-->
                        <v-flex xs12 sm6>
                          <v-text-field v-model="form.password" :rules="[formRules.required, formRules.lengthPassword]" type="password" label="Password" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="form.confirmPassword" :rules="[formRules.valuePassword]" type="password" label="Confirm Password" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 class="py-0"><span class="caption">Use 8 or more characters with a mix of letters, numbers & symbols</span></v-flex>
                        <v-layout xs12 justify-space-between class="mt-3">
                          <v-btn color="teal" class="white--text" :disabled="!valid" @click="submit()">Reset my password</v-btn>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-flex>
                <v-flex xs12 sm5 class="hidden-xs-only pt-5">
                  <v-img contain class="ma-3" src="/assets/key.png"></v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 d-flex justify-center>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      left
      :timeout="1000"
      top
    >
      Opps. Something goes wrong
    </v-snackbar>
  </v-content>
</template>

<script>
  export default {
    props: {
      navigateTo: Function
    },
    data() {
      return {
        dialog: {
          isShow: false,
          title: '',
          content: '',
        },
        valid: false,
        formRules: {
          required: v => !!v || 'This field is required',
          lengthPassword: v => v.length >= 8  || 'Your password should be at least 8 characters long',
          valuePassword: v => v === this.form.password || 'Your passwords do not match',
        },
        form: {
          password: '',
          confirmPassword: '',
        },
        snackbar: false,
      };
    },
    methods: {
      submit() {
        let self = this;
        if (this.$refs.form.validate()) {
          this.axios.post('public/password', {
            code: this.$route.query.code,
            password: this.form.password,
          }).then(() => {
            self.dialog.title = 'Password reset';
            self.dialog.content = 'Your password has been reset. Please use your new password to sign in.';
            self.dialog.isShow = true;
          }).catch(() => {
            self.dialog.title = 'Reset failed';
            self.dialog.content = 'Your password has not been changed. Please make a reset password request again.';
            self.dialog.isShow = true;
          });
        }
      },
      goHome() {
        window.history.back();
      },
    }
  };
</script>

